import { Injectable, ComponentRef } from "@angular/core";
import { Overlay, OverlayRef } from "@angular/cdk/overlay";
import { ComponentPortal } from "@angular/cdk/portal";
import { DsSplashScreenComponent } from "../components/ds-splash-screen/ds-splash-screen.component";
import { SplashScreenConfig } from "../components/types/splash-screen.type";

@Injectable({ providedIn: "root" })
export class DsSplashScreenService {
  private overlayRef: OverlayRef | null = null;
  private componentRef: ComponentRef<DsSplashScreenComponent> | null = null;
  private originalBodyOverflow: string = "";

  constructor(private overlay: Overlay) {}

  show(config?: SplashScreenConfig) {
    if (!this.overlayRef) {
      this.originalBodyOverflow = document.body.style.overflow;
      document.body.style.overflow = "hidden";

      this.overlayRef = this.overlay.create({
        hasBackdrop: true,
        backdropClass: "splash-screen-backdrop",
        positionStrategy: this.overlay.position().global().centerHorizontally().centerVertically(),
      });

      this.componentRef = this.overlayRef.attach(new ComponentPortal(DsSplashScreenComponent));

      if (this.componentRef.instance && config) {
        this.componentRef.instance.initial_message = config.initial_message ?? "";
        this.componentRef.instance.progress_message = config.progress_message ?? "Espera un momento...";
        this.componentRef.instance.fallback_message =
          config.fallback_message ?? "Esto puede tardar un poco más, seguimos trabajando…";
        this.componentRef.instance.description = config.description ?? "";
      }
    }
  }

  hide() {
    if (this.overlayRef) {
      const backdropElement = document.querySelector(".splash-screen-backdrop") as HTMLElement;

      if (backdropElement) {
        backdropElement.classList.add("cdk-overlay-backdrop-exiting");
        setTimeout(() => {
          this.clearOverlay();
        }, 200);
      } else {
        this.clearOverlay();
      }
    }
  }

  clearOverlay() {
    this.overlayRef?.detach();
    this.overlayRef?.dispose();
    this.overlayRef = null;
    this.componentRef = null;
    document.body.style.overflow = this.originalBodyOverflow;
    this.originalBodyOverflow = "";
  }
}
